import { graphql } from "@/lib/gql/__generated__";

export const SiteControllerSettingBeds24MasterDataSync_SettingPage_Mutation = graphql(`
	mutation SiteControllerSettingBeds24MasterDataSync_SettingPage(
		$input: SiteControllerSettingBeds24MasterDataSyncInput!
	) {
		siteControllerSettingBeds24MasterDataSync(input: $input) {
			userErrors
			siteControllerSetting {
				id
				hotelID
				siteControllerType
				password
				setUpRoomPriceByChillnn
				priceLinked
				beds24AuthenticationApiKey
				beds24AuthenticationPropKey
				beds24UseMultiplePropKey
				beds24AuthenticationPropKeys
				beds24RoomTypeMapping {
					beds24roomID
					beds24AuthenticationPropKey
					name
					roomID
				}
				beds24WebhookURL
				tll {
					tllID
					rooms {
						chillnnRoomID
						inSale
						tllRoomID
						tllRoomTypeName
						roomMinimumNum
						roomMaximumNum
						roomType
						relationalRoomTypeID
						inSaleForChillnnPlan
					}
					plans {
						roomStatus {
							tllRoomID
							inSale
						}
						tllPlanID
						planName
						isRoomPrice
						saleStart
						saleEnd
						stayableStart
						stayableEnd
						requiredPrepMilli
						minimumPeopleNum
						maximumPeopleNum
						minimumStayDate
						maximumStayDate
						acceptPrimarySchoolUpperGrade
						countablePrimarySchoolUpperGrade
						primarySchoolUpperGradeAmount
						primarySchoolUpperGradeAmountPolicyType
						acceptPrimarySchoolLowerGrade
						countablePrimarySchoolLowerGrade
						primarySchoolLowerGradeAmount
						primarySchoolLowerGradeAmountPolicyType
						acceptInfant
						countableInfant
						infantAmount
						infantPolicyType
						acceptInfantWithoutFoodAndBed
						countableInfantWithoutFoodAndBed
						infantWithoutFoodAndBedAmount
						infantWithoutFoodAndBedPolicyType
						planType
					}
					defaultPlan
				}
				airHostSettings {
					airHostPartnerID
					airHostAPIAccessToken
					airHostPropertyID
					chillnnRoomAndAirHostPricePlanMappings {
						chillnnRoomID
						airHostPlanID
						airHostRoomTypeID
						airHostRoomCheckInTime
						airHostRoomCheckOutTime
					}
				}
			}
		}
	}
`);
